module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-10.182cc0c1.png";